import { isValidArray } from "../../Services/validators";
import { isValidDate } from "./Constants";

export const defaultTracksFilter = {
  date: new Date().toISOString().split("T")[0]
};

export const tracksFilterData = () => [
  {
    dataCy: "tracks-date-range",
    key: "date",
    multiple: false,
    options: ["Select Date"],
    title: "DATE"
  }
];

export const tracksQueryPath = {
  dateRange: "timestamp",
  date: "timestamp"
};

export const tracksQueryBuilder = (filterData) => {
  const query = [];

  const addQuery = (path, operator, value) => {
    query.push(path, operator, value);
  };

  const addRangeQuery = (path, from, to) => {
    addQuery(path, ">=", +new Date(`${from}:00:00:00`));
    addQuery(path, "<=", +new Date(`${to}:23:59:59`));
  };

  Object.entries(filterData).forEach(([key, value]) => {
    if (!value) {
      return;
    }
    switch (key) {
      case "date":
        if (value && isValidDate(value)) {
          addRangeQuery(tracksQueryPath[key], value, value);
        }
        break;

      default:
        if (isValidArray(value)) {
          addQuery(tracksQueryPath[key], "in", value);
        }
        break;
    }
  });

  return query;
};
